const projectsSections = document?.querySelectorAll(".projects-section");

projectsSections?.forEach((item) => {
  const select = item?.querySelector(".top-content select");
  select?.addEventListener("change", function (e) {
    const value = e?.target?.value;
    const projects = item?.querySelectorAll(".project-card");
    projects?.forEach((el) => {
      const cardType = el?.dataset?.funded;

      if (
        (value === "current" && (!cardType || cardType === "false")) ||
        (value === "past" && cardType === "true") ||
        value === "all"
      ) {
        el.style.display = "block";
      } else {
        el.style.display = "none";
      }
    });
  });
});
